import * as stylex from "@stylexjs/stylex";

import { LoaderPrimitive, type LoaderPrimitiveProps } from "../primitives/LoaderPrimitive";

const styles = stylex.create({
	root: {
		color: "inherit",
	},
});

export function Inherit(props: LoaderPrimitiveProps) {
	return <LoaderPrimitive {...props} sx={[styles.root, props.sx]} />;
}
